import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, errorInfo) {
    console.error(error, errorInfo);
  }
  handleReload = () => {
    window.location.reload();
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh', backgroundColor: '#f0f0f0', padding: '20px' }}>
          <h1 style={{ fontSize: '2.5rem', marginBottom: '20px', color: '#333' }}>Oops!</h1>
          <p style={{ fontSize: '1.2rem', marginBottom: '30px', color: '#555', textAlign: 'center', maxWidth: '500px' }}>Something went wrong. Please try reloading the page.</p>
          <button onClick={this.handleReload} style={{ padding: '10px 20px', fontSize: '1rem', backgroundColor: '#007bff', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>Reload Page</button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
